import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/nc-puma-dealer")({
  component: () => <Outlet />,
});
